export default {
  'aws.title': '亚马逊订单',
  'aws.business': '产品/订单 ID',
  'aws.orderStatus': '订单状态',
  'aws.aswStatus': '亚马逊订阅状态',
  'aws.orderInfo': '订单信息',
  'aws.expireTime': '截止时间',
  'aws.createTime': '录入时间',
  'aws.pending': '待激活',
  'aws.unbind': '待绑定',
  'aws.bound': '已绑定',
  'aws.cancelled': '已取消',
  'aws.activeText': '{time} 后激活',
  'aws.operate': '操作',
  'aws.bindTips': '订单待激活，暂不可操作',
  'aws.bind': '绑定',
  'aws.engageLabOrder': 'EngageLab 订单',
  'aws.whatsapp.recharge': '充值',
  'aws.whatsapp.recharge.price': '充值金额',
  'aws.apppush.dataCenter': '数据中心',
  'aws.apppush.dau': 'DAU',
  'aws.apppush.vip': 'VIP 时长',
  'aws.email.tips': '邮件包/流量/独立 IP',
  'aws.email': '邮件数量',
  'aws.email.ip': '独立 IP 数量',
  'aws.email.flow': '充流量',
  'aws.choose.service': '选择 EngageLab 服务',
  'aws.choose.organization': '组织',
  'aws.choose.nodata': '无应用',
  'aws.choose.whatsapp': 'WhatsApp 商业账户',
  'aws.choose.app': '应用',
  'aws.order.title': '绑定 Amazon 订单',
  'aws.order.information': 'Amazon 订单信息',
  'aws.order.id': '订单 ID',
  'aws.order.product': '产品类型',
  'aws.bind.success': '绑定成功',
  'aws.bind.modal.create': '创建{appName}',
  'aws.month': '{number} 个月',
  'aws.allBusiness': '所有产品',
  'aws.order.status': '订单状态',
  'aws.aswStatus.refunded': '已退款',
  'aws.aswStatus.expired': '已到期',
  'aws.aswStatus.subscribed': '已订阅',
  'aws.aswStatus.upgraded': '已升级',
  'aws.aswStatus.renewed': '自动续购',
  'aws.aswStatus.cancelled': '已取消',
  'aws.aswStatus.refunded.tips': '本订单已在亚马逊申请退款，具体事宜请联系商务处理',
  'aws.aswStatus.upgraded.tips':
    '本订单在亚马逊进行了升级，如需在 EngageLab 享受升级后的权益，请联系销售协助处理。升级后的套餐如下：',
  'aws.bindTips.cancelled': '订单已在亚马逊取消',
  'aws.bindTips.unbind': '订单已在亚马逊 {status}，请联系商务处理',
  'aws.bindTips.unbind.status.refunded': '退款',
  'aws.bindTips.unbind.status.expired': '到期',
  'aws.bindTips.unbind.status.upgraded': '升级',
  'aws.bindTips.unbind.status': '退款/到期/升级',
  'aws.nodata': '暂无数据',
  'aws.jumpEmail':
    '请前往<a href="https://www.engagelab.com/console/email/#/email/{orgid}/sendSetting/domain" target="_blank">Email</a>配置域名',
};
